import React from 'react';
import PropTypes from 'prop-types';
import { CardSelector } from '../../sharedComponents/CardSelector';
import { AccountCard } from '../../sharedComponents/AccountCard';
import {
  getSavingAccountsList,
  getDisplayName,
  getAccountDisplayNumber,
} from '../../businessLogic/AccountsBL';
import { find } from 'lodash';

const SweepAccountCard = ({
  accountData,
  handleSweepAccountCardClick,
  showSweepAccountSelector,
  handleSelectSweepAccount,
  savingsAccountID,
  content,
}) => {
  const onAccountSelect = (savingsAccountID) => {
    handleSweepAccountCardClick();
    handleSelectSweepAccount(savingsAccountID, accountData);
  };
  const getSelectedAccount = (accounts, savingsAccountID) => {
    const selectedAccount = find(accounts, (account) => account.id === savingsAccountID);
    if (selectedAccount) {
      return {
        displayName: getDisplayName(selectedAccount),
        sortCode: getAccountDisplayNumber(selectedAccount).sortcode,
        type: selectedAccount.type,
        number: selectedAccount.number,
        accountNumber: getAccountDisplayNumber(selectedAccount).accNumber,
      };
    }
    return selectedAccount;
  };
  const getAccountsList = (accountData, savingsAccountID) => {
    const accounts = getSavingAccountsList(accountData);
    return (
      <div>
        <h3 className="c-m-payment-account-selector__title">{content.savingAccountsList}</h3>
        {accounts.map((account) => (
          <AccountCard
            key={account.id}
            id={account.id}
            number={account.number}
            type={account.type}
            sortCode={account.sortCode}
            accountNumber={account.accountNumber}
            name={account.displayName}
            currentBalance={account.currentBalance}
            availableBalance={account.availableBalance}
            onClick={onAccountSelect}
            isSelected={savingsAccountID === account.id}
          />
        ))}
      </div>
    );
  };
  return (
    <div className="c-o-payee-list--from-state">
      <CardSelector
        title={content.savingAccountSelection}
        iconType="PlusOutlineLarge"
        onClick={handleSweepAccountCardClick}
        selectedAccount={getSelectedAccount(accountData, savingsAccountID)}
      />
      {showSweepAccountSelector && getAccountsList(accountData)}
      <br />
    </div>
  );
};
SweepAccountCard.propTypes = {
  accountData: PropTypes.array,
  onAccountClick: PropTypes.func,
  handleSweepAccountCardClick: PropTypes.func,
  showSweepAccountSelector: PropTypes.bool,
  handleSelectSweepAccount: PropTypes.func,
  savingsAccountID: PropTypes.string,
  content: PropTypes.shape({
    savingAccountSelection: PropTypes.string,
  }),
};
export default SweepAccountCard;
